<mode-status-banner
  *ngIf="(googleSheetsEnabled$ | async) === false"
  status="warning"
  layout="full-width"
  data-test="report-schedules-google-sheets-disabled-msg"
>
  <div class="main-text">The Google Sheets Integration is disabled for this Workspace.</div>
  <div class="support-text">
    To create schedules and prevent existing ones from failing, enable the feature and make sure the Dataset creator
    reconnects to Google.
  </div>
</mode-status-banner>
<div class="schedules-actions">
  <div
    class="schedules-action-items"
    *ngIf="reportSchedulesEnabled && canCreateSchedule && (reportSchedulesFacade.reportSchedules$ | async)?.length"
  >
    <ng-container *ngIf="hasEditAcces">
      <p class="schedules-header-text" data-test="schedule-list-header-text">All schedules</p>
      <capra-button
        [disabled]="(googleSheetsEnabled$ | async) === false"
        data-test="create-new-schedule"
        text="New schedule"
        type="button"
        icon="{{ isAnalystStudio ? 'icon-calendar-add' : 'illo-calendar-add' }}"
        variant="secondary"
        [color]="neutralButtonColor"
        (clicked)="createNewSchedule.emit()"
      ></capra-button>
    </ng-container>
  </div>
</div>
<div class="schedules-scroll">
  <p class="empty-msg" *ngIf="!reportSchedulesEnabled" data-test="report-schedules-disabled-msg">
    Schedule creation is disabled for {{ workspaceTitle }}.
  </p>
  <ul
    class="schedules-list"
    *ngIf="(reportSchedulesFacade.reportSchedules$ | async)?.length"
    data-test="schedules-list"
  >
    <li *ngFor="let schedule of reportSchedulesFacade.reportSchedules$ | async" class="schedule-summary-list">
      <mode-schedule-list-description-tile
        [reportType]="report.type"
        [schedule]="schedule"
      ></mode-schedule-list-description-tile>
      <mode-schedule-list-actions
        *ngIf="schedule.canDeleteSchedule || schedule.canEditSchedule"
        [schedule]="schedule"
        (deleteSchedule)="deleteSchedule(schedule.token)"
        (editSchedule)="editSchedule(schedule)"
        (createOrDeleteSubscription)="createOrDeleteSubscription(schedule)"
      ></mode-schedule-list-actions>
    </li>
  </ul>
  <mode-loader
    *ngIf="reportSchedulesFacade.loading$ | async"
    type="tertiary"
    data-test="loading-indicator"
  ></mode-loader>
  <p
    class="empty-msg"
    *ngIf="
      !(reportSchedulesFacade.reportSchedules$ | async)?.length &&
      !initializingSchedules &&
      reportSchedulesEnabled &&
      hasEditAcces
    "
    data-test="empty-schedule-list-msg"
  >
    <ng-container *ngIf="report?.type === 'Report'">
      Create a schedule to refresh and deliver this Report regularly.
    </ng-container>
    <ng-container *ngIf="report?.type === 'DatasetReport'">
      Create a schedule to <br />
      {{ (datasetFacade.isSheetDataset$ | async) ? 'sync' : 'run' }}
      this Dataset on a cadence.
    </ng-container>
    <capra-button
      [disabled]="(googleSheetsEnabled$ | async) === false"
      class="empty-schedule-create-button"
      data-test="create-new-schedule"
      text="New schedule"
      type="button"
      icon="{{ isAnalystStudio ? 'icon-calendar-add' : 'illo-calendar-add' }}"
      variant="secondary"
      [color]="neutralButtonColor"
      (clicked)="createNewSchedule.emit()"
    ></capra-button>
  </p>
  <p
    class="empty-msg"
    *ngIf="
      !(reportSchedulesFacade.reportSchedules$ | async)?.length &&
      !initializingSchedules &&
      reportSchedulesEnabled &&
      !hasEditAcces
    "
  >
    This Report doesn't have any schedules to subscribe to.
  </p>
</div>
